import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const {isAuthenticated, loading} = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600">

                </div>
            </div>
        );
    }
    return isAuthenticated ? children : <Navigate to = "/login" />
};

export default PrivateRoute;